import React from 'react';
import ResponderMap from 'features/Responder/features/ResponderMap/index';

const TourMapEdit = (props) => (
  <ResponderMap
    enableTourTools={true}
    enableZones={false}
    enableTools={false}
    contextMenuMode="tour"
    activeSelectionOnly={true}
    focusOnPrimaryTourChange={true}
    autoSelectZones={false}
    enableInitialUserLocation={false}
    showResetZoomControl={true}
    {...props}
  />
);

export default TourMapEdit;
